export enum SearchSortBy {
  NOT_SET = '',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
  DISTANCE = 'DISTANCE',
  VIEWS = 'VIEWS',
  UPDATED = 'UPDATED',
  BEST_SELLERS = 'BEST_SELLERS',
  CHEAPEST_FIRST = 'CHEAPEST_FIRST',
  CHEAPEST_LAST = 'CHEAPEST_LAST',
}

/**
 * Function to convert a string into a valid SearchSortByEnum Instance
 * @param {string|undefined} option the string to convert to the enum.
 * @returns {SearchSortBy} the valid enum instance
 * - if option is not valid, it returns the default value
 */
export const searchSortFromString = (option?: string): SearchSortBy => {
  option = (option || '').toUpperCase();
  if ((SearchSortBy as any)[option]) {
    return (SearchSortBy as any)[option];
  }

  return SearchSortBy.NOT_SET;
};
